export const pathTabMap = {
  '/': 'home',
  '/api': 'api',
};

export const tabPathMap = {
  home: '/',
  api: '/api',
};

export const ICON_FILL_COLOR = 'rgba(40, 134, 222, 1)';
